module.exports = __webpack_public_path__ + "static/img/icon06.7a9f2427.png";